import { render, staticRenderFns } from "./company_chart.vue?vue&type=template&id=e50628a8&scoped=true"
import script from "./company_chart.vue?vue&type=script&lang=ts"
export * from "./company_chart.vue?vue&type=script&lang=ts"
import style0 from "./company_chart.vue?vue&type=style&index=0&id=e50628a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50628a8",
  null
  
)

export default component.exports